export const form = {
  id: undefined,
  name: '', // 名称
  line_id: undefined, // 发布平台
  template_type: 1, // 模板类型
  state: 1 // 模板状态
}

export const rules = {
  name: [
    { required: true, message: '请填写名称', trigger: 'change' }
  ],
  line_id: [
    { required: true, message: '请选择发布平台', trigger: 'change' }
  ],
  template_type: [
    { required: true, message: '请选择模板类型', trigger: 'change' }
  ],
  state: [
    { required: true, message: '请选择模板状态', trigger: 'change' }
  ]
}

export const columns = [
  {
    title: '字段名称',
    dataIndex: 'field_name',
    align: 'center'
  },
  {
    title: '字段标识',
    dataIndex: 'field',
    align: 'center'
  },
  {
    title: '是否必填',
    dataIndex: 'must',
    align: 'center',
    scopedSlots: { customRender: 'must' }
  },
  {
    title: '字段提示',
    dataIndex: 'field_tip',
    align: 'center',
    scopedSlots: { customRender: 'field_tip' }
  },
  {
    title: '字段备注',
    dataIndex: 'field_remark',
    align: 'center',
    scopedSlots: { customRender: 'field_remark' }
  },
  {
    title: '排序',
    dataIndex: 'sort',
    align: 'center',
    width: 80,
    scopedSlots: { customRender: 'sort' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  },
]

export const getFieldRemark = (record) => {
  try {
    const { field_type, field_value } = record
    if (['radio', 'checkbox', 'upload'].includes(field_type)) {
      if (field_type === 'upload') {
        return `${field_value?.[0]?.pic_num ?? 0}张`
      } else {
        return field_value.map(item => item.value).join('、')
      }
    }
    return '--'
  } catch (error) {
    return ''
  }
}
